import { Component, DestroyRef, ViewChild, inject } from '@angular/core';
import { ActivationEnd, Router, RouterOutlet } from '@angular/router';
import { filter, map } from 'rxjs';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import { SprocPageMenuComponent } from 'ngx-register-base';
import { PageToolbarComponent } from './sma-page-toolbar/page-toolbar.component';
import { NagrUserInfoComponent } from '../../components/user-info/nagr-user-info.component';
import { PageMenuStore } from './sma-page-menu/page-menu.store';
import build from '../../../build-version.json';
import { TuiHintDirective } from '@taiga-ui/core';

@Component({
  selector: 'sma-page',
  templateUrl: './sma-page.component.html',
  styleUrls: ['./sma-page.component.less'],
  standalone: true,
  imports: [
    RouterOutlet,
    PageToolbarComponent,
    NagrUserInfoComponent,
    SprocPageMenuComponent,
    TuiHintDirective,
  ],
})
export class SmaPageComponent {
  @ViewChild(SprocPageMenuComponent) private _menuCmp?: SprocPageMenuComponent;

  private readonly _store = inject(PageMenuStore);
  private readonly _router = inject(Router);
  private readonly _dr = inject(DestroyRef);

  menuItems = toSignal(
    this._store.fetchMenu().pipe(
      map((menu) => menu.data?.usr_v_main_menu),
      takeUntilDestroyed(this._dr)
    ),
    { initialValue: [] }
  );

  findActiveSection = (): void => {
    const findRoute = (path: string) => (this._menuCmp as any)?.findRoute(path);
    const resetSelection = () => (this._menuCmp as any)?.resetSelection();

    const currentRoute = this._router.url.split('/').find(Boolean) ?? '';
    if (currentRoute) {
      findRoute(currentRoute);
    } else {
      resetSelection();
    }

    this._router.events
      .pipe(
        filter((event) => event instanceof ActivationEnd),
        takeUntilDestroyed(this._dr)
      )
      .subscribe((data: ActivationEnd) => {
        const breadcrumb = data.snapshot.routeConfig?.path;

        if (!breadcrumb || breadcrumb === '' || breadcrumb === '**') {
          resetSelection();
          return;
        }
        findRoute(breadcrumb);
      });
  };

  protected get version(): string {
    return build.buildVersion;
  }

  protected get versionHint(): string {
    return `АИС Награды: ${this.version}`;
  }
}
